<script lang="ts" setup>
import { Button } from '@forgd/ui-kit/button'
import { Popover, PopoverContent, PopoverTrigger } from '@forgd/ui-kit/popover'
import { AdjustmentsHorizontalIcon } from '@heroicons/vue/24/outline'

const props = withDefaults(defineProps<{
  title?: string
  description?: string
  descriptionClass?: string
  titleClass?: string
  type?: 'page' | 'section'
}>(), {
  type: 'section',
})

const slots = useSlots()

const resolvedTitleClass = computed(() =>
  props.titleClass ?? (props.type === 'page' ? 'text-xl' : 'text-sm'),
)

const directionClass = computed(() =>
  props.type === 'page' ? 'flex-col-reverse' : 'flex-col',
)

const showMobileCustomize = computed(() =>
  props.type === 'section' && !!slots.action,
)
</script>

<template>
  <div
    data-el="PrHeader"
    class="flex w-full gap-5 sm:flex-row sm:items-center sm:justify-between"
    :class="directionClass"
  >
    <div class="flex w-full flex-col gap-1">
      <slot name="title" :title-class="resolvedTitleClass">
        <h1 class="font-semibold text-primal" :class="resolvedTitleClass">
          {{ title }}
        </h1>
      </slot>
      <p v-if="description" class="text-xs font-normal text-secondary" :class="descriptionClass">
        {{ description }}
      </p>
    </div>
    <template v-if="showMobileCustomize">
      <Popover>
        <PopoverTrigger as-child>
          <Button variant="outline" size="sm" class="w-fit md:hidden">
            Customize
            <AdjustmentsHorizontalIcon />
          </Button>
        </PopoverTrigger>
        <PopoverContent
          side="bottom"
          align="end"
          class="max-w-[90vw] min-w-70 space-y-3 bg-neutral-200 p-4"
        >
          <slot name="action" />
        </PopoverContent>
      </Popover>
      <div class="hidden md:contents">
        <slot name="action" />
      </div>
    </template>
    <slot v-else name="action" />
  </div>
</template>
